import React, { useEffect } from "react";
import { Button } from "reactstrap";
import activePlayer from "../../../../assets/images/OCH/active-player.png";
import avatar from "../../../../assets/images/OCH/avatar.png";
import { compose } from "redux";
import { connect } from "react-redux";
import { withSocket } from "../../../../socket/context";
import card from "../../../../assets/images/card";
import { removeUser } from "../../../../components/shared/utils";
import _ from "lodash";
import Socket from "../../../../socket/socket";
const PlayersCard = (props) => {
  const param = _.get(props, "paramsReducer.gameObj.screens.och");
  const roomData = _.get(props, "gameReducer.roomObj");
  const players = _.get(roomData, "users");
  const current_player = _.get(roomData, "game_state.current_player");
  const current_card = _.get(roomData, "game_state.current_card");
  const playerData = _.get(roomData, "game_state.players");
  const playerQ = _.get(roomData, "game_state.player_queue");
  const round_order = _.get(roomData, "game_state.round_order");
  const passedArray = _.get(roomData, "game_state.passed");
  const status = _.get(roomData, "game_state.status");

  const firstPlayer = _.filter(players, (item) => {
    if (item.player_id === current_player) {
      return item;
    }
  });

  let otherPlayer = _.filter(players, (item) => {
    if (item.player_id !== current_player) {
      return item;
    }
  });

  let result = [];
  round_order.forEach(function (key) {
    var found = false;
    players &&
      players.filter(function (item) {
        if (item.player_id == key) {
          result.push(item);
          found = true;
          return false;
        } else return true;
      });
  });

  let cardLength = 0;

  const delPlayer = (data) => {
    const roomObj = roomData;
    removeUser(roomObj, data);
  };

  useEffect(() => {
    return Socket.addListener("recall-bot-och", () => {
      let data = {
        action: "bot-och",
        roomId: roomData.id,
      };
      setTimeout(() => {
        Socket.sendMessage(data);
      }, 3000);
    });
  }, []);

  // const call_bot_och = () => {
  //   const user = [];
  //   players &&
  //     players.filter(function (item) {
  //       if (item.player_id == current_player) {
  //         user.push(item);
  //       }
  //     });
  //   let user_Name = user[0]?.user_id;
  //   if (user_Name.includes("bot")) {
  //     if (status === "Playing") {
  //       let data = {
  //         action: "bot-och",
  //         roomId: roomData.id,
  //         debug: true
  //       };
  //       Socket.sendMessage(data);
  //     }
  //   }
  // };

  useEffect(() => {
    const user = [];
    players &&
      players.filter(function (item) {
        if (item.player_id == current_player) {
          user.push(item);
        }
      });
    let user_name = user[0]?.user_id;
    if (user_name?.includes("bot")) {
      if (status === "Playing") {
        let data = {
          action: "bot-och",
          roomId: roomData.id,
        };
        setTimeout(() => {
          Socket.sendMessage(data);
        }, 3000);
      }
    }
  }, [JSON.stringify(current_card), JSON.stringify(current_player)]);

  return (
    <>
      {/* {firstPlayer &&
          <div className={`playingCardsBoxWrapper card-1`}>
          <div
            className={`playingCardsBox ${
              firstPlayer[0].player_id === roomData?.game_state?.current_player
                ? " current_player"
                : ""
            }`}
          >
            <div className="players">
              <h3>{firstPlayer[0].display_name}</h3>
              <img src={firstPlayer[0].profile_image} className="profile" />
              <h3 className="scores">1000</h3>
             
            </div>
            <div className="playing-multiple-cards-wrap">
              <div className="playingCardsWrap">
                {playerData.map((player) => {
                  if (firstPlayer[0].player_id === player.player_id) {
                    cardLength = player.player_hand.length;
                    return (
                      <>
                        {player.player_hand &&
                          player.player_hand.length > 0 &&
                          player.player_hand.map((cards) => {
                            return (
                              <>
                                <img src={param.cardback_img} />
                              </>
                            );
                          })}
                      </>
                    );
                  }
                })}
              </div>
              <div className="count">{cardLength}</div>
            </div>
          </div>
          {roomData &&
            roomData?.game_state?.pass_counter > 0 &&
            firstPlayer[0].player_id !== roomData?.game_state?.current_player && (
              <p className="status">
                {param ?      param.passed_text : "PASSED"}
              </p>
            )}
        </div>} */}

      {/* <button onClick={call_bot_och} style={{"zIndex": 99, "position": "fixed", "top": "50%", "left": "50%"}}>bot-och</button> */}

      {result &&
        result.length > 0 &&
        result.map((user, index) => {
          return (
            <div className={`playingCardsBoxWrapper card-${index + 1}`}>
              <div
                className={`playingCardsBox ${
                  user.player_id === roomData?.game_state?.current_player
                    ? " current_player"
                    : ""
                }`}
              >
                <div className="players">
                  {/* <Button
                    color="themePink"
                    className="cross"
                    onClick={() => delPlayer(user)}
                  >
                    <img src={Cross} />
                  </Button> */}
                  {/* {user.player_id === roomData?.game_state?.current_player &&
                  <img src={activePlayer} className="activePlayer" />
                  } */}
                  <h3 className="name">{user.display_name}</h3>
                  <img
                    // src={user.profile_image !== '' ? user.profile_image : avatar }
                    src={
                      user.profile_image
                        .toString()
                        .includes("default-profile-icon")
                        ? avatar
                        : user.profile_image.toString().includes("profileImage")
                        ? avatar
                        : user.profile_image
                    }
                    className="profile"
                  />
                  {playerData.map((player) => {
                    if (user.player_id === player.player_id) {
                      cardLength = player.player_hand.length;
                      return (
                        <>
                          <h3 className="scores">{player.total_score || 0}</h3>
                        </>
                      );
                    }
                  })}
                </div>
                <div className="playing-multiple-cards-wrap">
                  <div className="playingCardsWrap">
                    {playerData.map((player) => {
                      if (user.player_id === player.player_id) {
                        cardLength = player.player_hand.length;
                        return (
                          <>
                            {player.player_hand &&
                              player.player_hand.length > 0 &&
                              player.player_hand.map((cards) => {
                                return (
                                  <>
                                    <img src={param.cardback_img} />
                                  </>
                                );
                              })}
                          </>
                        );
                      }
                    })}
                  </div>
                  <div className="count">{cardLength}</div>
                </div>
              </div>
              {passedArray.includes(user.player_id) && (
                <p className="status">{param ? param.passed_text : "PASSED"}</p>
              )}
            </div>
          );
        })}
    </>
  );
};
const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer,
  loaderDetails: state.loaderDetails,
  paramsReducer: state.paramsReducer,
});
const mapDispatchToProps = (dispatch) => {
  return {
    // setIsLoading: (data) => dispatch(loaderAction.setIsLoading(data)),
  };
};
export default compose(
  withSocket,
  connect(mapStateToProps, mapDispatchToProps)
)(PlayersCard);
// export default PlayersCard
